import { useQuery } from 'react-query'
import { getResultsRSC } from "data/Querys"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { prepareRscForFinishedPhase } from "components/sports/mpn/helper/MpnHelpers";
import { isFinishedStatus } from "helpers/status";

export function usePhaseFinished() {
    const { mirs_competition, mirs_rsc, mirs_language } = useUrlFriendlyToParameters()

    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsDataLastPhase', mirs_competition, prepareRscForFinishedPhase(mirs_rsc), mirs_language],
            queryFn: getResultsRSC,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        }
    );

    if (isLoading || isError) return { isPhaseFinished: false}; 
    
    const resultStatus = data?.results?.status?.code;

    if (!resultStatus) return { isPhaseFinished: false};

    return { isPhaseFinished: isFinishedStatus(resultStatus)};
}



